var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_9722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_9722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20.4783C3.45 20.4783 2.97933 20.2828 2.588 19.8918C2.196 19.5002 2 19.0296 2 18.4801V7.49028C2 6.94079 2.196 6.47056 2.588 6.07959C2.97933 5.68795 3.45 5.49213 4 5.49213H8V3.49398C8 2.94449 8.196 2.47393 8.588 2.08229C8.97933 1.69132 9.45 1.49583 10 1.49583H14C14.55 1.49583 15.021 1.69132 15.413 2.08229C15.8043 2.47393 16 2.94449 16 3.49398V5.49213H20C20.55 5.49213 21.021 5.68795 21.413 6.07959C21.8043 6.47056 22 6.94079 22 7.49028V18.4801C22 19.0296 21.8043 19.5002 21.413 19.8918C21.021 20.2828 20.55 20.4783 20 20.4783H4ZM10 5.49213H14V3.49398H10V5.49213ZM20 14.4838H15V16.482H9V14.4838H4V18.4801H20V14.4838ZM11 14.4838H13V12.4857H11V14.4838ZM4 12.4857H9V10.4875H15V12.4857H20V7.49028H4V12.4857Z",
    fill: "#453F3A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCenter);
export default __webpack_public_path__ + "static/media/business_center.1bea6f868060274a9c4b49c90f4aef58.svg";
export { ForwardRef as ReactComponent };